module.exports = __webpack_public_path__ + "static/media/apartment11.88aa074f.jpg";